var moduleMap = {
	"./PerDiemConfigTable": () => {
		return Promise.all([__webpack_require__.e(267), __webpack_require__.e(364), __webpack_require__.e(536), __webpack_require__.e(884), __webpack_require__.e(199), __webpack_require__.e(747), __webpack_require__.e(445), __webpack_require__.e(340)]).then(() => (() => ((__webpack_require__(2150)))));
	},
	"./PerDiemCrewTable": () => {
		return Promise.all([__webpack_require__.e(267), __webpack_require__.e(364), __webpack_require__.e(612), __webpack_require__.e(884), __webpack_require__.e(199), __webpack_require__.e(747), __webpack_require__.e(445), __webpack_require__.e(419)]).then(() => (() => ((__webpack_require__(5955)))));
	},
	"./PerDiemDisputeDashboard": () => {
		return Promise.all([__webpack_require__.e(267), __webpack_require__.e(102), __webpack_require__.e(884), __webpack_require__.e(199), __webpack_require__.e(747), __webpack_require__.e(128)]).then(() => (() => ((__webpack_require__(2723)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});